module.exports = __webpack_public_path__ + "static/assets/2b0fda5db9ce9a64dc6b46c170ec33a5.svg";